import React from 'react';
import _ from 'lodash';
import Alert from '@mui/material/Alert';
import metricSettings from 'relevant-shared/reportData/metricSettings';
import { PrebidDataObjects } from 'relevant-shared/prebid/prebidDataObjects.js';
import ByType from './byType';

const renderBeforeDisableBidder = ({ renderContext }) => {
	const { obj } = renderContext;
	const { disableFromHb } = obj;
	const pbConfigFields = renderContext.pbConfigFields();
	const settings = _.get(pbConfigFields, ['rlvBySsp', 'value', obj.id, 'value']);
	const countryFilter = ['filterType', 'countries'].every((fld) => !_.isEmpty(settings?.[fld]?.value));
	const perfFilter = !!settings?.perfValue?.value;
	let dpoReason;
	if (countryFilter && perfFilter) {
		dpoReason = <>Disabled in some countries <i>and</i> subject to automatic disabling by performance filter in</>;
	} else if (countryFilter) {
		dpoReason = 'Disabled in some countries by';
	} else if (perfFilter) {
		dpoReason = 'Subject to auto-disabling by performance filter in';
	}
	const disableReasons = _.pickBy({
		hasCountry: dpoReason && (
			<>
				{dpoReason} &nbsp;
				<b>{pbConfigFields.rlvBySsp.description}</b>&nbsp;
				settings in&nbsp;
				<b>{PrebidDataObjects.genericPbConfigData.name}</b>
			</>
		),
		disableFromHb: disableFromHb && (
			<>
				This bidder is disabled from header bidding in the SSP settings
			</>
		),
	});
	if (_.isEmpty(disableReasons)) {
		return null;
	}
	return (
		<>
			{_.entries(disableReasons).map(([key, elm]) => (
				<Alert key={key} severity="info">
					{elm}
				</Alert>
			))}
		</>
	);
};

const renderDpoFilterValue = (props) => {
	const metric = props.field().parentObject(2)?.perfMethod?.value;
	const { isNegativeIfIncrease } = metricSettings.hb[metric] || {};
	return ByType.Number.renderData({
		...props,
		description: isNegativeIfIncrease ? 'MAXIMUM value' : 'Minimum value',
	});
};

export default {
	renderBeforeDisableBidder,
	renderDpoFilterValue,
};
